import { useCallback, useMemo } from 'react';

import { useValuesNavigation } from 'utils/hooks';

import { IdentifiedTileGridBlockTile } from './useIdentifiedTileGridBlockData';

type Args = {
  identifiedTiles: IdentifiedTileGridBlockTile[];
  tileSlug: string | undefined;
  onSelectTile: (slug: string | undefined) => void;
};

export function useTileGridBlockTileNavigation({
  identifiedTiles,
  tileSlug,
  onSelectTile,
}: Args) {
  const tileSlugs = useMemo(
    () => identifiedTiles.map((tile) => tile.tileSlug),
    [identifiedTiles]
  );

  const { previous, hasPrevious, next, hasNext } = useValuesNavigation({
    currentValue: tileSlug,
    values: tileSlugs,
    onChangeValue: onSelectTile,
  });

  const closeTile = useCallback(() => onSelectTile(undefined), [onSelectTile]);

  return {
    closeTile,
    hasPreviousTile: hasPrevious,
    previousTile: previous,
    hasNextTile: hasNext,
    nextTile: next,
  };
}
